import React from "react";
import "./FooterPublic.css";

export default function FooterPublic() {
  return (
    <footer className="public-footer">
      {/* ---------- BLACK BAND (logo + navigation) ---------- */}
      <div className="footer-main">
        <div className="footer-main-inner">
          {/* Left logo */}
          <a href="https://mongrel.live" className="footer-logo">
            <img src="/mongrel-logo.png" alt="mongrel" />
          </a>

          {/* Center nav */}
          <nav className="footer-nav">
            <a href="https://mongrel.live/about" target="_blank" rel="noopener noreferrer">
              about
            </a>
            <a href="https://mongrel.live/services" target="_blank" rel="noopener noreferrer">
              services
            </a>
            <a href="https://mongrel.live/blog" target="_blank" rel="noopener noreferrer">
              blog
            </a>
            <a href="https://mongrel.live/platform" target="_blank" rel="noopener noreferrer">
              platform
            </a>
            <a href="https://mongrel.live/contact" target="_blank" rel="noopener noreferrer">
              contact
            </a>
          </nav>
        </div>
      </div>

      {/* ---------- GRADIENT & LEGAL SECTION ---------- */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>©2026 MONGREL.LIVE</p>
          <div className="footer-links">
            <a href="https://mongrel.live/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <span>|</span>
            <a href="https://mongrel.live/terms" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>
            <span>|</span>
            <a href="https://mongrel.live/delivery-refund-policy" target="_blank" rel="noopener noreferrer">
              Refund Policy
            </a>
            <span>|</span>
            <a href="https://mongrel.live/sales-agreement" target="_blank" rel="noopener noreferrer">
              Sales Agreement
            </a>
            <span>|</span>
            <a href="https://mongrel.live/cookie-policy" target="_blank" rel="noopener noreferrer">
              Cookie Policy (EU)
            </a>
            <span>|</span>
            <a href="https://mongrel.live/gdpr" target="_blank" rel="noopener noreferrer">
              GDPR
            </a>
            <span>|</span>
            <a href="https://mongrel.live/kvkk" target="_blank" rel="noopener noreferrer">
              KVKK
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
